import type { AxiosResponse } from 'axios';

const ROUTE = '/timesheets';

async function getTimesheet(params: Record<string, unknown>): Promise<AxiosResponse> {
    return await window.tenantAxios.get(ROUTE, { params });
}

async function getTimesheetByUserAndWeek(params: Record<string, unknown>): Promise<AxiosResponse> {
    return await window.tenantAxios.get(`${ROUTE}/find-by-user-week`, { params });
}

async function getCurrentTimesheetEntry(params: Record<string, unknown>): Promise<AxiosResponse> {
    return await window.tenantAxios.get(`${ROUTE}/current-timesheet-entry`, { params });
}

async function getTimesheetById(timesheet: number | string): Promise<AxiosResponse> {
    return await window.tenantAxios.get(`${ROUTE}/${timesheet}`);
}

async function clockIn(timesheetData: Record<string, unknown>): Promise<AxiosResponse> {
    return await window.tenantAxios.post(`${ROUTE}/clock-in`, timesheetData);
}

async function clockOut(data: Record<string, unknown>, timesheetEntry: number | string): Promise<AxiosResponse> {
    return await window.tenantAxios.patch(`${ROUTE}/clock-out/${timesheetEntry}`, data);
}

async function pauseShift(timesheetEntryId: number | string): Promise<AxiosResponse> {
    return await window.tenantAxios.post(`${ROUTE}/pause/${timesheetEntryId}`);
}

async function resumeShift(timesheetEntryId: number | string): Promise<AxiosResponse> {
    return await window.tenantAxios.patch(`${ROUTE}/resume/${timesheetEntryId}`);
}

async function createTimesheet(data: Record<string, unknown>): Promise<AxiosResponse> {
    return await window.tenantAxios.post(ROUTE, data);
}

async function bulkUpdateTimesheetEntries(data: Record<string, unknown>): Promise<AxiosResponse> {
    return await window.tenantAxios.post(`${ROUTE}/bulk-update`, data);
}

async function timesheetApprove(timesheet: number | string, data: Record<string, unknown>): Promise<AxiosResponse> {
    return await window.tenantAxios.patch(`${ROUTE}/${timesheet}/approve`, data);
}

async function timesheetDecline(timesheet: number | string, data: Record<string, unknown>): Promise<AxiosResponse> {
    return await window.tenantAxios.patch(`${ROUTE}/${timesheet}/decline`, data);
}

async function upcomingJobs(params: Record<string, unknown>, user: number | string): Promise<AxiosResponse> {
    return await window.tenantAxios.get(`${ROUTE}/upcoming-jobs/${user}`, { params });
}

async function getTimesheetEntriesByTimesheet(timesheet: number | string): Promise<AxiosResponse> {
    return await window.tenantAxios.get(`${ROUTE}/${timesheet}/timesheet-entries`);
}

async function createTimesheetEntry(timesheet: number | string, data: Record<string, unknown>): Promise<AxiosResponse> {
    return await window.tenantAxios.post(`${ROUTE}/${timesheet}/timesheet-entries`, data);
}

async function updateTimesheetEntry(
    timesheet: number | string,
    data: Record<string, unknown>,
    timesheetEntry: number | string,
): Promise<AxiosResponse> {
    return await window.tenantAxios.patch(`${ROUTE}/${timesheet}/timesheet-entries/${timesheetEntry}`, data);
}

async function analytics(params: Record<string, unknown> = {}): Promise<AxiosResponse> {
    return await window.tenantAxios.get(`${ROUTE}/dashboard-analytics`, { params });
}

async function searchOrder(params: Record<string, unknown> = {}): Promise<AxiosResponse> {
    return await window.tenantAxios.get(`${ROUTE}/search-orders`, { params });
}

async function searchTask(params: Record<string, unknown> = {}): Promise<AxiosResponse> {
    return await window.tenantAxios.get(`${ROUTE}/search-tasks`, { params });
}

export default {
    clockIn,
    clockOut,
    pauseShift,
    resumeShift,
    bulkUpdateTimesheetEntries,
    timesheetApprove,
    timesheetDecline,
    getCurrentTimesheetEntry,
    getTimesheetById,
    getTimesheet,
    getTimesheetByUserAndWeek,
    upcomingJobs,
    createTimesheet,
    getTimesheetEntriesByTimesheet,
    createTimesheetEntry,
    updateTimesheetEntry,
    analytics,
    searchOrder,
    searchTask,
};
